export class UpdateObjectStoreScanMethodResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objectStoreScanMethod",
            "baseName": "objectStoreScanMethod",
            "type": "ObjectStoreScanMethod",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateObjectStoreScanMethodResponse.attributeTypeMap;
    }
    constructor() {
    }
}
